// frontend/src/pages/auth/AuthLayout.tsx
export function AuthLayout({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <main className="min-h-screen bg-bg-primary text-text-primary grid place-items-center px-lg">
      <div className="w-full max-w-[24rem]">
        {/* Wordmark, matching the sidebar: the q is the only brand mark, and
            a coloured tile is exactly what this design language rules out. */}
        <div className="flex items-center gap-sm mb-xl">
          <span
            className="font-wordmark font-medium"
            style={{ fontSize: '21px', letterSpacing: '-0.02em' }}
          >
            <span className="sr-only">PriceQ</span>
            <span aria-hidden>
              price<span className="text-brand-mark">q</span>
            </span>
          </span>
        </div>
        <h1 className="font-sans text-h2 mb-lg">{title}</h1>
        <div className="bg-bg-secondary border border-border-subtle rounded-md p-lg">{children}</div>
      </div>
    </main>
  );
}
